import FAQ from './faq';
export default function findAConsultant() {
    find()
}

function find() {
    const form = document.querySelector('#consultantLocatorTradeForm');

    if (form) {
        
        const postCodeInput = form.querySelector('select[name="Regions"]');
        let fieldValue = null;
        let type = null;

        // Auto-search when dropdown selection changes
        postCodeInput.addEventListener("change", function (e) {
            let input = postCodeInput.value;
            if (input && input !== "") {
                fieldValue = input;
                type = 'search';
                
                console.log(input);
                setLocationData(input);
            }
        });

        function setLocationData(region) {
            
            var formData = new FormData(form);
            // Set the Region parameter with the guid value
            formData.set('Region', region);
            let resultsContainer = document.querySelector('.result-container');

            fetch(form.getAttribute('data-url'), {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: formData
            })
                .then(response => response.text())
                .then(html => {
                    resultsContainer.innerHTML = html
                    FAQ();
                })
                .catch(error => console.log(error.message))
                .finally();

            //added timer to allow the map api to return correct results
            setTimeout(updateDataLayer, 10000);
        }

        function updateDataLayer() {

            // Push data to dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'location',
                'type': type,
                'fieldValue': fieldValue
            });
        }

        function filterResults() {
            const stockistFilterContainer = document.querySelector(".stockist-filters");

            if (stockistFilterContainer) {
                let stockistFilters = document.querySelectorAll(".stockist-filter");

                stockistFilters.forEach(element => {
                    element.addEventListener("click", function (e) {

                        let stockists = document.querySelectorAll('.stockists .accordion');
                        let values = element.value.split(',');

                        stockists.forEach(stockist => {
                            if (!values.includes(stockist.getAttribute('data-map-id'))) {
                                stockist.classList.remove('active');
                                var panel = stockist.nextElementSibling;
                                panel.classList.remove("active");
                            }
                        });
                    });
                });
            }
        }

        filterResults();
    }
}